(function () {
  /**
   * @awaitingdeprecation
   *
   * @ngdoc factory
   * @name ProductDescriptor
   * @description This class describes a product that is affected by an action.
   *   For example: a product is removed from cart
   */
  angular.module('binky.core.product').factory('ProductDescriptor', factory);

  function factory(_, binkySrc2, feature) {
    /**
     * @description ProductDescriptor class on AngularJS
     * @deprecated
     */
    class ProductDescriptor {
      /**
       * @description Constructor
       * @deprecated
       *
       * @param {Object} [options] Initialization options
       * @param {Number} [options.assignableLicenseCount] Number of available licenses
       * @param {String} [options.licenseType] License type
       * @param {Number} [options.numberSelected] User selected quantity
       * @param {Number} [options.numberUnassigned] Number of unassigned licenses
       * @param {String} [options.offer_id] Offer ID
       * @param {String} [options.productBucket] The source bucket where the product was selected from
       * @param {String} [options.productName] License type
       * @param {String} [options.searchTerm] Search term
       */
      constructor(options = {}) {
        initModel(this, options);
      }
    }

    /**
     * @description ProductDescriptor class based on React model
     */
    class ProductDescriptor2 extends binkySrc2.services.product.ProductDescriptor {}

    return feature.isEnabled('temp_react_port_analytics_descriptors')
      ? ProductDescriptor2
      : ProductDescriptor;

    //////////

    function initModel(model, options) {
      _.assignIn(
        model,
        _.pick(options, [
          'assignableLicenseCount',
          'licenseType',
          'numberSelected',
          'numberUnassigned',
          'offer_id',
          'productBucket',
          'productName',
          'searchTerm',
        ])
      );
    }
  }
})();
